import React from "react";
import {observer} from "mobx-react";
import {useViewController} from "data/services/locator";
import {Bindings} from "data/constants/bindings";
import {Modal, Typography} from "@mui/material";
import styled from "@emotion/styled";
import {PrimaryButton} from "views/components/style";
import {type IModalLosePicksController} from "views/components/modals/modal_lose_picks/modal_lose_picks.controller";
import CloseIcon from "assets/img/icons/modal/close.svg?react";

const ModalContent = styled.div`
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
	gap: 12px;
	outline: none;
	max-width: 600px;
	width: 100%;
	background: #fff;
	padding: 40px 20px 20px;
	border-radius: 4px;
	text-align: center;

	@media screen and (max-width: 640px) {
		max-width: unset;
		left: 24px;
		right: 24px;
		width: auto;
		transform: translateY(-50%);
	}

	button {
		max-width: 300px;
	}

	h3 {
		color: #000;
		text-align: center;
		font-family: var(--fontFamilyBase);
		font-size: 26px;
		font-style: normal;
		font-weight: 700;
		line-height: 130%; /* 26px */
		text-transform: uppercase;
		margin: 10px 0 10px;
	}
`;

const CloseBlock = styled.div`
	width: 24px;
	height: 24px;
	display: flex;
	justify-content: flex-end;
	align-items: center;
	position: absolute;
	top: 20px;
	right: 20px;
	cursor: pointer;
`;

export const ModalLosePicks: React.FC = observer(() => {
	const {i18n, isOpen, close, onLoginBySSO} = useViewController<IModalLosePicksController>(
		Bindings.ModalLosePicksController
	);

	return (
		<Modal open={isOpen}>
			<ModalContent>
				<CloseBlock onClick={close}>
					<CloseIcon />
				</CloseBlock>
				<Typography variant={"h3"}>
					{i18n.t("modals.lose_picks.title", "Don`t lose your picks")}
				</Typography>
				<Typography variant={"subtitle1"}>
					{i18n.t(
						"modals.lose_picks.description",
						"Sign in to save your playoff picture and be in the running for Prize"
					)}
				</Typography>
				<PrimaryButton
					variant="contained"
					size="large"
					onClick={onLoginBySSO}
					sx={{margin: "10px auto"}}>
					{i18n.t("modals.lose_picks.button")}
				</PrimaryButton>
			</ModalContent>
		</Modal>
	);
});
